export const unAssignColor = "#474aec";
export const noAvailableColor = "#E62E05";
export const availableColor = "#101828";
export const borderAvailableColor = "#D0D5DD";